<template>
  <div>
    <div class="product-container">
      <Bread
        first-name="产品中心"
        metertype="智慧水务"
        meter-name="CPU卡水表电子模块"
      ></Bread>
      <div class="top-title">
        <h1>西安星年物联网</h1>
      </div>
      <div class="info">
        <el-row :gutter="16">
          <el-col :span="16">
            <h1>CPU卡水表电子模块</h1>
            <div class="introduce">
              <div class="title">产品介绍</div>
              <div class="intro-text">
                <p>
                  CPU卡水表是目前比较安全的卡类水表，由于采用了CPU卡芯片技术，采用3DES算法，并具有COS指令系统可与城市一卡通无缝对接。
                </p>
              </div>
            </div>
            <div class="trait">
              <div class="title">功能特点</div>
              <div class="intro-text">
                <p>
                  1、采用比较安全的CPU卡芯片技术；
                </p>
                <p>
                  2、采用3DES算法，无破解可能；
                </p>
                <p>3、城市一卡通无缝对接；</p>
                <p>
                  4、超低功耗，先进的探卡技术，减少错误操作；
                </p>
                <p>
                  5、具有断电存储功能及防拆卸设计。
                </p>
              </div>
            </div>
            <div></div>
          </el-col>
          <el-col :span="8">
            <!-- <div class="meter-img">
              <img src="@/svg/NB.jpg" />
            </div> -->
            <div class="meter-img">
              <img src="@/svg/cpu.png" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.box {
  font-size: 42px;
}
.top-title {
  padding: 100px 0 0 0;
  border-bottom: 4px solid #4e56c5;
  h1 {
    color: #4e56c5;
  }
}
.info {
  h1 {
    text-indent: 1cm;
    color: #3ab0e7;
  }
  .introduce {
    padding: 60px 0 0 0;
    .title {
      text-indent: 1cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 1cm;
      line-height: 30px;
    }
  }
  .trait {
    padding: 60px 0 0 0;
    .title {
      text-indent: 1cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 1cm;
      line-height: 30px;
    }
  }
  background-color: #fff;
  margin: 100px 0 0 0;
  .meter-img {
    img {
      width: 370px;
    }
  }
}
</style>
